import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Box,
  Typography,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ComputerIcon from "@mui/icons-material/Computer";

function isMobileDevice() {
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
    navigator.userAgent
  );
}

function isChromeBrowser() {
  const ua = navigator.userAgent;
  // Chrome but not Edge, Opera, or Samsung Browser
  return (
    /Chrome\//.test(ua) &&
    !/Edg\//.test(ua) &&
    !/OPR\//.test(ua) &&
    !/SamsungBrowser\//.test(ua)
  );
}

const SESSION_KEY = "browser_warning_dismissed";

export default function BrowserWarningPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const alreadyDismissed = sessionStorage.getItem(SESSION_KEY);
    if (alreadyDismissed) return;

    const needsWarning = isMobileDevice() || !isChromeBrowser();
    if (needsWarning) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    sessionStorage.setItem(SESSION_KEY, "true");
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Slide}
      TransitionProps={{ direction: "up" }}
      keepMounted
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          p: 1,
          background: "linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)",
          boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
        },
      }}
    >
      {/* Bouton fermer */}
      <IconButton
        onClick={handleClose}
        size="small"
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          color: "text.secondary",
        }}
        aria-label="Fermer"
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      <DialogContent sx={{ textAlign: "center", pt: 4, pb: 2, px: 4 }}>
        {/* Icône */}
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 72,
            height: 72,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
            mb: 2.5,
            boxShadow: "0 8px 24px rgba(25,118,210,0.3)",
          }}
        >
          <ComputerIcon sx={{ color: "#fff", fontSize: 38 }} />
        </Box>

        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ mb: 1.5, lineHeight: 1.3, color: "text.primary" }}
        >
          Expérience optimale recommandée
        </Typography>

        <Typography
          variant="body2"
          sx={{ opacity: 0.8, lineHeight: 1.7, color: "text.secondary" }}
        >
          Pour une meilleure expérience, veuillez accéder à la plateforme
          depuis un <strong>ordinateur</strong> via{" "}
          <strong>Google Chrome</strong>.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          variant="contained"
          onClick={handleClose}
          sx={{
            px: 4,
            borderRadius: "50px",
            background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
            color: "#fff",
            textTransform: "none",
            fontWeight: 600,
            boxShadow: "0 4px 14px rgba(25,118,210,0.4)",
            "&:hover": {
              background: "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)",
              boxShadow: "0 6px 20px rgba(25,118,210,0.5)",
            },
          }}
        >
          J'ai compris
        </Button>
      </DialogActions>
    </Dialog>
  );
}
